import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Form from 'components/form';
import Input from 'components/form/Input';
import Select from 'components/form/Select';
import Button from 'components/common/Button';
import { useQuery } from 'react-apollo';
import { GET_USERS } from 'graphql/admin/users';

const FormItem = Form.FormItem;

const useStyles = makeStyles((theme) => ({

}));

const mapOptions = (response) =>
  response.data?.users.map((i) => ({
    value: i.user_id,
    label: `${i.user_first_name} ${i.user_last_name}`,
  }));

const GroupForm = ({ group, onSubmit, onCancel, form }) => {
  const { getFieldDecorator, validateFields } = form;
  const lcData = useQuery(GET_USERS, {
    variables: { user_type: 'lead_coach', includeChildren: false },
  });
  const hcData = useQuery(GET_USERS, {
    variables: { user_type: 'head_coach', includeChildren: false },
  });
  const fcData = useQuery(GET_USERS, {
    variables: { user_type: 'fa_coach', includeChildren: false },
  });
  const handleSubmit = () => {
    return validateFields().then(onSubmit);
  };

  return (
    <Box>
      <Form>
        <FormItem>
          {getFieldDecorator('name', {
            rules: [{ required: true }],
          })(<Input label="Group name" />)}
        </FormItem>
        <FormItem>
          {getFieldDecorator('lc_id', {
            rules: [{ required: true }],
          })(
            <Select
              transformValue
              isMulti={false}
              loading={lcData.loading}
              label="CC"
              options={mapOptions(lcData)}
            />,
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator('hc_id', {
            rules: [{ required: true }],
          })(
            <Select
              transformValue
              isMulti={false}
              loading={hcData.loading}
              label="HC"
              options={mapOptions(hcData)}
            />,
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator('fc_id', {
            rules: [{ required: true }],
          })(
            <Select
              transformValue
              isMulti={false}
              loading={fcData.loading}
              label="FC"
              options={mapOptions(fcData)}
            />,
          )}
        </FormItem>
        <Box>
          <Button onClick={onCancel}>Cancel</Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">
            Submit
          </Button>
        </Box>
      </Form>
    </Box>
  );
};

export default Form.create()(GroupForm);
